import { DocumentSimStudioData } from '@/types';
import client from './client';

async function get() {
  const { data } = await client.get<DocumentSimStudioData[]>(`/documentsSimStudioData`);
  return data;
}

async function update({
  id,
  enabled,
  simstudioUrl,
  simstudioApiKey,
  workflowId,
}: {
  id: string;
  enabled: boolean;
  simstudioUrl: string;
  simstudioApiKey?: string;
  workflowId: string;
}) {
  const payload: any = {
    enabled,
    simstudioUrl,
    workflowId,
  };

  if (simstudioApiKey && simstudioApiKey.trim() !== '') {
    payload.simstudioApiKey = simstudioApiKey;
  }

  const { data } = await client.patch<DocumentSimStudioData>(`/documentsSimStudioData/${id}`, payload);
  return data;
}

async function create({
  id,
  displayName,
  simstudioUrl,
  simstudioApiKey,
  workflowId,
}: {
  id: string;
  displayName: string;
  simstudioUrl: string;
  simstudioApiKey: string;
  workflowId: string;
}) {
  const { data } = await client.post<DocumentSimStudioData>(`/documentsSimStudioData`, {
    id,
    displayName,
    simstudioUrl,
    simstudioApiKey,
    workflowId,
  });
  return data;
}

async function remove(id: string) {
  await client.delete(`/documentsSimStudioData/${id}`);
}

export const documentsSimStudioData = {
  get,
  update,
  create,
  remove,
};
